import React from 'react'
import { AddressPage } from '../presentation/AddressPage'
import { Footer } from '../presentation/Footer'
import { Header } from '../presentation/Header'

export const Address = () => {
  return (
    <div>
      <Header />
      <AddressPage />
      <Footer />
    </div>
  )
}